import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { compareVersionDiff } from '../../services/locatorDriftService';
import { errorMessage } from './locatorDriftUtils';

export const compareVersionDiffAsync = createAsyncThunk(
  'locatorDrift/versionDiff/compare',
  async (payload, { rejectWithValue }) => {
    try {
      return await compareVersionDiff(payload);
    } catch (error) {
      return rejectWithValue(errorMessage(error));
    }
  },
);

const versionDiffSlice = createSlice({
  name: 'versionDiff',
  initialState: {
    comparison: null,
    analyzing: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(compareVersionDiffAsync.pending, (state) => {
        state.analyzing = true;
        state.error = null;
      })
      .addCase(compareVersionDiffAsync.fulfilled, (state, action) => {
        state.analyzing = false;
        state.comparison = action.payload;
      })
      .addCase(compareVersionDiffAsync.rejected, (state, action) => {
        state.analyzing = false;
        state.error = action.payload;
      });
  },
});

export default versionDiffSlice.reducer;
